<template>
   <div class="container-xxl padding-container-matrix">
       <div class="row justify-content-center">
           <div class="col-matrix">
               <div class="row justify-content-center">
                   <div class="col-video-embed">
                        <div class="video-embed-wraper" v-html="videoEmbed"></div>
                   </div>
               </div>
            </div>
        </div>
   </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
// import AssetLoader from '@/components/helpers/AssetLoader'

export default {
    name: 'videoEmbed',
    components: {
        // AssetLoader
    },
    props: {
        videoEmbed: {
            type: String,
            required: true,
        },
    },
    computed: {
        pageIsLoaded() {
            return this.contentIsLoaded && this.globalsIsLoaded
        },
        ...mapState(['contentIsLoaded', 'globalsIsLoaded']),
        ...mapGetters(['seo', 'content', 'globals']),
    },
    methods: {
        ...mapActions(['setErrorsReportMsg']),
    },
    // On loaded...
    mounted() {},
}
</script>
